import tts from './TTS'

export const activePassportsByStation = (
  memberships: { call_sign: string }[] | undefined
): string => {
  if (memberships !== undefined && memberships.length > 0) {
    let userMemberships: string
    if (memberships.length === 1) {
      userMemberships = memberships[0].call_sign
    } else {
      const callSignArray: string[] = []
      for (let i = 0; i < memberships.length; i++) {
        callSignArray.push(memberships[i].call_sign)
      }
      userMemberships = callSignArray.join(',')
    }
    return userMemberships
  }
  return ''
}

export const handleForbiddenAction = (
  messageVisible: boolean,
  setMessageVisible: (arg0: boolean) => void,
  timeout: number,
  ttsString: string
): (() => void) | undefined => {
  let uiMessageTimeoutId: NodeJS.Timeout | null = null

  if (!messageVisible) {
    tts.stopRead()
    tts.addTextToRead(ttsString)
    setMessageVisible(true)

    uiMessageTimeoutId = setTimeout(() => {
      setMessageVisible(false)
      clearTimeout(uiMessageTimeoutId as NodeJS.Timeout)
    }, timeout)

    return () => clearTimeout(uiMessageTimeoutId as NodeJS.Timeout)
  }
}
